const baseInfo = {
  baseInfoDB: "",
  billDB: "",
  isEncrypt: false, // 未启用数据脱敏但是检测到数据加密
  ischangesite: false, // 是否切换网点跳转过来的
  requestErrorMethodName: [], // 保存请求失败的方法名称
  CssAndJsVersion: "", // web.config配置的静态资源版本号
  isUpdateMode: false, // 是否属于更新模式
  compatible: function () {
    if (!Promise.allSettled) {
      Promise.allSettled = function (promises) {
        return Promise.all(
          promises.map(promise =>
            Promise.resolve(promise).then(
              value => ({
                status: 'fulfilled',
                value
              }),
              reason => ({
                status: 'rejected',
                reason
              })
            )
          )
        );
      }
    }
  },
  start: function (ischangesite) { // 开始加载用户数据(依赖tms-indexDB.js)
    this.compatible();
    const g = this;
    g.ischangesite = ischangesite;
    sessionStorage.removeItem("requestErrorMethodName");
    return new Promise((resolve, reject) => {
      g.openIndexDBComplete().finally(() => {
        g.requestMust().then(() => {
          Promise.allSettled([
            g.loadwd(),
            g.loadArg(),
            g.loadcw(),
            g.loadkh(),
          ]).finally(() => {
            g.requestErrorMethodName = [...new Set(g.requestErrorMethodName)];
            g.requestErrorMethodName.length && sessionStorage.setItem("requestErrorMethodName", JSON.stringify(g.requestErrorMethodName));
            if (g.isEncrypt) {
              return reject('未启用数据脱敏但是检测到数据加密！请联系管理员！');
            } else {
              return resolve(g.CssAndJsVersion);
            }
          })
        }).catch(message => {
          return reject(message); // 必要接口调用失败
        })
      });
    });
  },
  update: function () { // 重新请求失败的接口(依赖tms-indexDB.js)
    this.compatible();
    this.isUpdateMode = true;
    let requestErrorMethodName = sessionStorage.getItem("requestErrorMethodName")
    if (!requestErrorMethodName) return;
    const g = this;
    try {
      requestErrorMethodName = JSON.parse(requestErrorMethodName);
    } catch (error) {
      requestErrorMethodName = [];
    }
    if (!(Array.isArray(requestErrorMethodName) && requestErrorMethodName.length)) return;
    g.openIndexDBComplete().finally(() => {
      Promise.allSettled(requestErrorMethodName.map(methodName => {
        return g[methodName]();
      })).finally(() => {
        sessionStorage.removeItem("requestErrorMethodName"); //无论成功与否都清除
      })
    });
  },
  openIndexDBComplete: function () { // 全部indexDB开启完成的回调
    const g = this;
    return new Promise((resolve, reject) => {
      if (window.useIndexDB) {
        Promise.all([
          g.openIndexDBItemComplete('baseInfoDB', 'baseInfoStore'),
          g.openIndexDBItemComplete('billDB', 'billStore')
        ]).then(() => {
          return resolve();
        }).catch(() => {
          return reject();
        })
      } else {
        return reject();
      }
    });
  },
  openIndexDBItemComplete: function (dbname, store) { // 指定indexDB开启完成的回调
    const g = this;
    return new Promise((resolve, reject) => {
      if (
        !(window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.msIndexedDB) ||
        !dbname
      ) {
        return reject();
      }
      g[dbname] = new OpenIndexDB({
        dbname: "TMS-indexDB-" + getNewUserInfo().TMSCode + "-" + store,
        dbversion: 1,
        store: store,
        oncomplete: function () {
          return resolve();
        }
      });
    });
  },
  requestMust: function () { // 必要的请求接口，需要全部成功，才能执行下一步（用户权限、参数设置、静态版本号、系统缓存）
    const g = this;
    let arr = [];
    arr.push(g.getUserRole());
    arr.push(g.getArg());
    arr.push(g.getCssAndJsVersion());
    if (!this.ischangesite) {
      arr.push(g.setSystemCacheInfo());
    }
    return Promise.all(arr);
  },
  request: function (opt) { // 根据条件判断，是否需要请求接口
    const g = this;
    return new Promise((resolve, reject) => {
      if (!opt.api) {
        return reject();
      }

      // 发送请求接口
      const send = function () {
        g.requestServer(opt).then(() => {
          return resolve();
        }).catch(() => {
          g.requestErrorMethodName.push(opt.methodName);
          return reject();
        });
      };

      if (g.ischangesite && !opt.alwaysServer && window.useIndexDB && g[opt.dbname]) {
        // 切换网点，优先使用indexDB数据
        g[opt.dbname].getData(opt.key, function (result) {
          if (result) {
            let data = result.value;
            opt.callback(data);
            return resolve();
          } else {
            send();
          }
        })
      } else {
        send();
      }
    });
  },
  saveDataArray: [ // set indexDB需要数组的key
    'linePrintSetting',
    'esiteAddr',
    'selectVehicleXinghao',
    'selectOutacc_c',
    'selectAccsend_c',
    'selectChaufferInfoBill',
    'selectVehicleInfoBill',
    'line',
    'site',
    'middlesite'
  ],
  requestServer: function (opt) { // 封装后的java接口方法
    const g = this;
    return new Promise((resolve, reject) => {
      // 记录请求开始时间
      const startTime = Date.now();
      const apiName = opt.api;
      $.javaAjax({
        url: opt.api,
        type: 'POST',
        dataType: "JSON",
        useCustomError: true,
        success: function (res) {
          // 计算请求耗时
          const endTime = Date.now();
          const duration = endTime - startTime;
          console.log(`接口${apiName} 请求耗时: ${duration}ms`);
          // 这里埋点
          const payload = {
            apiName,
            duration
          }
          window.lib && window.lib.track && window.lib.track.monitor && window.lib.track.monitor({
            category: 'custom',
            metric: {
              type: 'Gauge',
              value: duration,
              name: 't9bs.druraton.loadpage.api',
              tags: {},
              sections: payload
            },
            attrs: payload,
            ext: payload
          })
          if (res.success) {
            if (opt.key != "PubilcDataDecryptColumn" && !g.isUpdateMode && g.isEncryptButNotUseDataDecrypt(res)) {
              g.isEncrypt = true;
              return reject();
            }
            if (window.useIndexDB && g[opt.dbname]) {
              let isSetArray = g.saveDataArray.indexOf(opt.key) > -1;
              let data = (Array.isArray(res.data) && !isSetArray ? res : res.data) || (isSetArray ? [] : {});
              g[opt.dbname].setData({
                key: opt.key,
                value: data,
                callback: function () {
                  opt.callback(res.data);
                  return resolve();
                }
              });
            } else {
              opt.callback(res.data);
              return resolve();
            }
          } else {
            return reject();
          }
        },
        error: function () {
          return reject();
        }
      })
    });
  },
  getUserRole: function () { // 获取用户权限组
    // 记录请求开始时间
    const startTime = Date.now();
    return new Promise((resolve, reject) => {
      GetRedisCacheByKey('_', 'TMSversion')
      // 计算请求耗时
      const endTime1 = Date.now();
      const duration1 = endTime1 - startTime;
      console.log(`接口/vueCacheInterface/loadRedisCacheDataByKey 请求耗时: ${duration1}ms`);
      // 这里埋点
      const payload1 = {
        apiName: '/vueCacheInterface/loadRedisCacheDataByKey',
        duration: duration1
      }
      window.lib && window.lib.track && window.lib.track.monitor && window.lib.track.monitor({
        category: 'custom',
        metric: {
          type: 'Gauge',
          value: duration1,
          name: 't9bs.druraton.loadpage.api',
          tags: {},
          sections: payload1
        },
        attrs: payload1,
        ext: payload1
      })
      GetUserAllRoles('', 'isUpdate', 'isNoShowMessage', 'async').then((data, success) => {
        // 计算请求耗时
        const endTime = Date.now();
        const duration = endTime - startTime;
        console.log(`接口/tmsApi/interfaceMethod/loaddata/qsp_get_rgps_tmsbs_v2 请求耗时: ${duration}ms`);
        // 这里埋点
        const payload = {
          apiName: '/tmsApi/interfaceMethod/loaddata/qsp_get_rgps_tmsbs_v2',
          duration: duration
        }
        window.lib && window.lib.track && window.lib.track.monitor && window.lib.track.monitor({
          category: 'custom',
          metric: {
            type: 'Gauge',
            value: duration,
            name: 't9bs.druraton.loadpage.api',
            tags: {},
            sections: payload
          },
          attrs: payload,
          ext: payload
        })
        if (success) {
          return resolve();
        } else {
          return reject('获取用户权限信息失败！请重新登录');
        }
      });
    });
  },
  getArg: function () { // 获取系统设置
    const g = this;
    // 记录请求开始时间
    const startTime = Date.now();
    return new Promise((resolve, reject) => {
      getNeedWVData("", false, true, true).then((obj, success) => {
        const endTime = Date.now();
        const duration = endTime - startTime;
        console.log(`接口/tmsApi/interfaceMethod/query/qsp_get_arg_tpl_dynamic 请求耗时: ${duration}ms`);
        // 这里埋点
        const payload = {
          apiName: '/tmsApi/interfaceMethod/query/qsp_get_arg_tpl_dynamic',
          duration: duration
        }
        window.lib && window.lib.track && window.lib.track.monitor && window.lib.track.monitor({
          category: 'custom',
          metric: {
            type: 'Gauge',
            value: duration,
            name: 't9bs.druraton.loadpage.api',
            tags: {},
            sections: payload
          },
          attrs: payload,
          ext: payload
        })
        if (success) {
          window.useIndexDB && g.baseInfoDB && g.baseInfoDB.setData({
            key: 'arg',
            value: [obj]
          });
          sessionStorage.setItem("tmsbsgsname", obj.gsname || '');
          sessionStorage.setItem("tmsbswxsendtype", obj.wxsendtype || '');
          sessionStorage.setItem("replacetitle", obj.replacetitle || '');
          sessionStorage.setItem("replacetitleout", obj.replacetitleout || '');
          sessionStorage.setItem("Printvesion", obj.printvesion) || '';
          sessionStorage.setItem("tmsbsopendshk", obj.opendshk || '');
          sessionStorage.setItem("tmssendtositeneedconfirm", obj.sendtositeneedconfirm || '');
          sessionStorage.setItem("sitetvlevel", obj.sitetvlevel || '');
          sessionStorage.setItem("tmsbsPrintLabelMaxNum", obj.PrintLabelMaxNum || '');
          sessionStorage.setItem("morendays", obj.morendays || '');
          sessionStorage.setItem("isopenesiteprice", obj.isopenesiteprice || '');
          sessionStorage.setItem("isytpz", obj.ytpz || '');
          sessionStorage.setItem("piaoju", obj.piaoju || '');
          sessionStorage.setItem("is_sb", obj.is_sb || '');
          sessionStorage.setItem("isopenpcb", obj.isopenpcb || '');
          sessionStorage.setItem("esiteshowtype", obj.esiteshowtype || '');
          sessionStorage.setItem("isshowpcbfee", obj.isshowpcbfee || '');
          sessionStorage.setItem("vehicledays", obj.vehicledays || '');
          sessionStorage.setItem("defaultaccounttype", obj.defaultaccounttype || 1);
          sessionStorage.setItem("queryunittype", obj.queryunittype);
          sessionStorage.setItem("hksxfbase", obj.hksxfbase);
          sessionStorage.setItem("isshowremark", obj.isshowremark);
          sessionStorage.setItem("sumaccdaishousxfmax", obj.sumaccdaishousxfmax || -1);
          sessionStorage.setItem("sumaccdaishousxfmin", obj.sumaccdaishousxfmin || -1);
          sessionStorage.setItem("islsbank", obj.islsbank || ''); //启用临商银行对接
          sessionStorage.setItem("defaultaccdeclare", obj.defaultaccdeclare || -1); //默认申明价值
          sessionStorage.setItem("dacc", obj.dacc);
          sessionStorage.setItem("isyizhanconnect", obj.isyizhanconnect);
          sessionStorage.setItem("isallowmakebill", obj.isallowmakebill); //是否允许开票
          sessionStorage.setItem("isallowmakebill_sl", obj.isallowmakebill_sl); //是否允许双联开票
          sessionStorage.setItem("isfysh", obj.isfysh);
          sessionStorage.setItem("isnofeewarn", obj.isnofeewarn); //非免费且无费用时进行提示
          sessionStorage.setItem("isshowhxcolor", obj.isshowhxcolor); //改单时已核销数据显示背景色
          sessionStorage.setItem("ispushpcb", obj.ispushpcb); //是否启用 拼车宝资料
          sessionStorage.setItem("isopenocr", obj.isopenocr); //是否启用 OCR
          sessionStorage.setItem("qkcheckmorelevel", obj.qkcheckmorelevel); //是否启用 下级审核
          sessionStorage.setItem("ishidedataforall", obj.ishidedataforall); //是否启用 权限组隐藏信息不区分网点
          sessionStorage.setItem("showselectbar", obj.showselectbar); //是否展示表格选中面板
          sessionStorage.setItem("showFilter", obj.showFilter);
          sessionStorage.setItem("tmsbswttx_is_wttxbx", obj.is_wttxbx);
          sessionStorage.setItem("tmsbsIsUseKuaidi", obj.isusekuaidi);
          sessionStorage.setItem("tmsbsidtype", obj.idtype);
          sessionStorage.setItem("iconshowtype", obj.iconshowtype); //右下角图标显示方式
          sessionStorage.setItem("echartauth", obj.echartauth || ""); //大数据
          sessionStorage.setItem("isshowmyb", obj.isshowmyb || ""); //是否显示满运宝开票
          sessionStorage.setItem("ismybmakebill", obj.ismybmakebill || ""); //是否默认勾选满运宝开票
          sessionStorage.setItem("isfilterendclear", obj.isfilterendclear || ""); //是否默认勾选满运宝开票
          sessionStorage.setItem("isdecrypt", obj.isdecrypt || 0); //默认是否显示脱敏数据 空或0 默认带*    1 显示原文
          sessionStorage.setItem("isbillcustom", obj.isbillcustom || 0); //是否启动开单自定义 0 不启用 1 启用
          sessionStorage.setItem("smsid", obj.smsid || ""); //是否启动短信
          sessionStorage.setItem("wx_orders", obj.wx_orders || ""); // 是否有微信下单权限
          localStorage.setItem("isShowShare", obj.isShowShare || ""); //是否启用微信分享运单信息
          
          if (obj.ext) {
            try {
              var ext = JSON.parse(obj.ext || '{}')
              sessionStorage.setItem("onlySupportEnterSearch", ext.onlySupportEnterSearch || ""); // 是否只支持按 enter建筛选
            } catch (error) {
              
            }
          }
          return resolve();
        } else {
          return reject('获取系统参数设置失败！请重新登录');
        }
      });
    });
  },
  setSystemCacheInfo: function () { // 设置系统缓存
    // 记录请求开始时间
    const startTime = Date.now();
    return new Promise((resolve, reject) => {
      // 计算请求耗时
      const endTime = Date.now();
      const duration = endTime - startTime;
      console.log(`接口/vueCacheInterface/loginOkForSetRedis 请求耗时: ${duration}ms`);
      // 这里埋点
      const payload = {
        apiName: '/vueCacheInterface/loginOkForSetRedis',
        duration: duration
      }
      window.lib && window.lib.track && window.lib.track.monitor && window.lib.track.monitor({
        category: 'custom',
        metric: {
          type: 'Gauge',
          value: duration,
          name: 't9bs.druraton.loadpage.api',
          tags: {},
          sections: payload
        },
        attrs: payload,
        ext: payload
      })
      SetSystemCacheInfo(true).then(success => {
        if (success) {
          return resolve();
        } else {
          return reject('获取系统缓存数据失败！请重新登录');
        }
      });
    })
  },
  getCssAndJsVersion: function () { // 获取静态资源版本号
    // 记录请求开始时间
    const startTime = Date.now();
    return new Promise((resolve, reject) => {
      getWebConfigSetting('CssAndJsVersion', true, true).then((value, success) => {
        // 计算请求耗时
        const endTime = Date.now();
        const duration = endTime - startTime;
        console.log(`接口/web/common/config/getWebConfigAppSettings 请求耗时: ${duration}ms`);
        // 这里埋点
        const payload = {
          apiName: '/web/common/config/getWebConfigAppSettings',
          duration: duration
        }
        window.lib && window.lib.track && window.lib.track.monitor && window.lib.track.monitor({
          category: 'custom',
          metric: {
            type: 'Gauge',
            value: duration,
            name: 't9bs.druraton.loadpage.api',
            tags: {},
            sections: payload
          },
          attrs: payload,
          ext: payload
        })
        if (success) {
          this.CssAndJsVersion = value;
          return resolve();
        } else {
          return reject('获取系统配置失败！请重新登录');
        }
      });
    })
  },
  loadwd: function () { // 加载网点数据相关的接口
    return Promise.allSettled([
      this.getLine(),
      this.getSite(),
      this.getMiddlesite()
    ]);
  },
  loadArg: function () { // 加载参数设置相关的接口
    let arr = [];
    let arg = getNeedWVData();
    arr.push(this.getLltInfo());
    arr.push(this.getPrintModel());
    arr.push(this.getWarehouPrintModel());
    arr.push(this.getUserDefaultInfo());
    arr.push(this.getLinePrintSetting());
    arr.push(this.selectVehicleXinghao());
    arr.push(this.selectOutacc_c());
    arr.push(this.selectAccsend_c());
    arr.push(this.selectShipperno());
    arr.push(this.selectDailibsite());
    arr.push(this.PubilcDataDecryptColumn());
    if (getNewUserInfo().TMSCode == "79953") {
      arr.push(this.selectProductcode());
    }
    if (arg.esiteshowtype == 3) {
      arr.push(this.getEsiteAddr());
    }
    if (arg.isallowmakebill == 1) {
      arr.push(this.selectChaufferInfoBill());
      arr.push(this.selectVehicleInfoBill());
    }
    // 是否启动开单自定义
    if (arg.isbillcustom == 1) {
      arr.push(this.getDefaultBillingTemplateList());
    }
    return Promise.allSettled(arr);
  },
  loadcw: function () { // 加载财务资料相关的接口
    return Promise.allSettled([this.getParm()]);
  },
  loadkh: function () { // 获取客户资料相关的接口
    return Promise.allSettled([
      this.getShipper(),
      this.getConsignee()
    ]);
  },
  // 客户资料初始化
  khloadingState: {
    length: 2, // 需要loading 的接口数量
    array: []
  },
  // 检查客户资料是否全部加载完毕
  checkKhLoading: function (type) {
    const g = this;
    g.khloadingState.array.push(type);
    if (g.khloadingState.array.length == g.khloadingState.length) {
      sessionStorage.setItem("noUseStorage", "yes");
    }
  },
  // 获取发货客户资料
  getShipper: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/getShipper',
      key: 'fhInfo',
      dbname: 'billDB',
      methodName: "loadkh", // 该接口失败，则获取客户资料的接口，进入首页都要重新请求 
      callback: function (data) {
        if (!window.useIndexDB) {
          if (Array.isArray(data) && data.length <= 5000) {
            sessionStorage.setItem("bill_fhInfo_arr", JSON.stringify({
              data: data
            }));
          }
        }
        g.checkKhLoading("fh");
      },
      alwaysServer: true
    });
  },
  // 获取收货客户资料
  getConsignee: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/getConsignee',
      key: 'shInfo',
      dbname: 'billDB',
      methodName: "loadkh", // 该接口失败，则获取客户资料的接口，进入首页都要重新请求 
      callback: function (data) {
        if (!window.useIndexDB) {
          if (Array.isArray(data) && data.length <= 5000) {
            sessionStorage.setItem("bill_shInfo_arr", JSON.stringify({
              data: data
            }));
          }
        }
        g.checkKhLoading("sh");
      },
      alwaysServer: true
    });
  },
  getParm: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/getParm',
      key: 'cwsetting',
      dbname: 'baseInfoDB',
      methodName: "getParm",
      callback: function () {
        sessionStorage.setItem('cwsetting', 1)
      }
    });
  },
  // 网点资料初始化
  wdloadingState: {
    length: 3,
    array: [],
    line: [],
    site: [],
    middlesite: []
  },
  // 检查网点数据是否全部加载完
  checkWdLoading: function (type) {
    const g = this;
    g.wdloadingState.array.push(type);
    if (g.wdloadingState.array.length == g.wdloadingState.length) {
      g.formatSiteData();
    }
  },
  // 获取线路
  getLine: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/getLine',
      key: 'line',
      dbname: 'baseInfoDB',
      methodName: "loadwd", // 该接口失败，则获取网点数据的接口，进入首页都要重新请求 
      callback: function (data) {
        g.wdloadingState.line = $.extend(true, [], data);
        g.checkWdLoading("line");
      }
    });
  },
  // 获取网点
  getSite: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/getSite',
      key: 'site',
      dbname: 'baseInfoDB',
      methodName: "loadwd", // 该接口失败，则获取网点数据的接口，进入首页都要重新请求
      callback: function (data) {
        g.wdloadingState.site = $.extend(true, [], data);
        g.checkWdLoading("site");
      }
    });
  },
  // 获取中转地
  getMiddlesite: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/getMiddlesite',
      key: 'middlesite',
      dbname: 'baseInfoDB',
      methodName: "loadwd", // 该接口失败，则获取网点数据的接口，进入首页都要重新请求
      callback: function (data) {
        g.wdloadingState.middlesite = $.extend(true, [], data);
        g.checkWdLoading("middlesite");
      }
    });
  },
  // 格式化 拼接数据
  formatSiteData: function () {
    const g = this;
    // 格式化中转地
    let middlesite = {};
    let middlesiteMoreInfo = {};
    g.wdloadingState.middlesite.forEach(function (item, index) {
      item.text = item.site;
      if (middlesite[item.parentsite]) {
        middlesite[item.parentsite].push({
          text: item.site
        });
        middlesiteMoreInfo[item.parentsite].push(item);
      } else {
        middlesite[item.parentsite] = [{
          text: item.site
        }];
        middlesiteMoreInfo[item.parentsite] = [item];
      }
    });
    // 格式化网点
    let site = {};
    // 拼接接口 /PublicData/GetintervalNoAll?param=0 返回的数据
    let GetintervalNoAll0 = [];
    // 拼接接口 /PublicData/GetintervalNoAll?param=1 返回的数据
    let GetintervalNoAll1 = [];
    g.wdloadingState.site.forEach(function (item, index) {
      let obj = {
        text: item.bsite
      };
      item.text = item.bsite;
      let obj_all = JSON.parse(JSON.stringify(item));
      obj_all.accbili = 0;
      obj_all.eaccbili = 0;

      if (middlesite[item.bsite]) {
        obj.children = middlesite[item.bsite]
        obj_all.children = middlesiteMoreInfo[item.bsite];
      };

      site[item.line] ? site[item.line].push(obj) : site[item.line] = [obj];
      GetintervalNoAll0.push(item);
      GetintervalNoAll1.push(obj_all);
    })
    // 因为页面读取是同步的 所以存到 sessionStorage
    sessionStorage.setItem("GetintervalNoAll0", JSON.stringify(GetintervalNoAll0));
    sessionStorage.setItem("GetintervalNoAll1", JSON.stringify(GetintervalNoAll1));
    
    // 格式化线路
    let line = [];
    if (getNewUserInfo().TMSCode != "60773") {
      line = g.wdloadingState.line.map(function (item, index) {
        let obj = {
          "id": index + 1,
          "text": item.line
        };
        if (site[item.line]) {
          obj.children = site[item.line]
        };
        return obj;
      });
    } else {
      g.wdloadingState.line.forEach(function (item, index) {
        if (site[item.line]) {
          line.push({
            "id": line.length + 1,
            "text": item.line,
            "children": site[item.line]
          });
        }
      });
    }
    // /PublicData/Getinterval?level=3 返回的数据
    line.unshift({
      "id": "all",
      "text": "全部"
    });
    sessionStorage.setItem("siteData3", JSON.stringify(line));
  },
  // 获取路路通设置
  getLltInfo: function () {
    sessionStorage.setItem("tmsbswttx_ppprice", '');
    sessionStorage.setItem("tmsbswttx_llprice", '');
    sessionStorage.setItem("tmsbswttx_ppfl", '');
    sessionStorage.setItem("tmsbswttx_llfl", '');
    sessionStorage.setItem("tmsbswttx_if_auto", '');
    return Promise.resolve()
    // const g = this;
    // return g.request({
    //   api: '/loadInfo/getLltInfo',
    //   key: 'llt',
    //   dbname: 'baseInfoDB',
    //   methodName: "getLltInfo",
    //   callback: function (data) {
    //     let obj = data && data[0] || {};
    //     sessionStorage.setItem("tmsbswttx_ppprice", obj.tmsbswttx_ppprice || '');
    //     sessionStorage.setItem("tmsbswttx_llprice", obj.tmsbswttx_llprice || '');
    //     sessionStorage.setItem("tmsbswttx_ppfl", obj.tmsbswttx_ppfl || '');
    //     sessionStorage.setItem("tmsbswttx_llfl", obj.tmsbswttx_llfl || '');
    //     sessionStorage.setItem("tmsbswttx_if_auto", obj.tmsbswttx_if_auto || '');
    //   }
    // });
  },
  // 获取打印设置
  getPrintModel: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/getPrintModel',
      key: 'print',
      dbname: 'baseInfoDB',
      methodName: "getPrintModel",
      callback: function (data) {
        let obj = data && data[0] || {};
        sessionStorage.setItem("tmsbsTydPrinter", obj.tmsbsTydPrinter || '');
        sessionStorage.setItem("tmsbsBqPrinter", obj.tmsbsBqPrinter || '');
        sessionStorage.setItem("tmsbsQdPrinter", obj.tmsbsQdPrinter || '');
        sessionStorage.setItem("tmsbsXfPrinter", obj.tmsbsXfPrinter || '');
        sessionStorage.setItem("tmsbsZzPrinter", obj.tmsbsZzPrinter || '');
        sessionStorage.setItem("tmsbsThdPrinter", obj.tmsbsThdPrinter || '');
        sessionStorage.setItem("tmsbsHkpzPrinter", obj.tmsbsHkpzPrinter || '');
        sessionStorage.setItem("tmsbsPzlPrinter", obj.tmsbsPzlPrinter || '');
        sessionStorage.setItem("tmsbsDefaultTydModelId", obj.tmsbsDefaultTydModelId || '');
        sessionStorage.setItem("tmsbsDefaultXfModelId", obj.tmsbsDefaultXfModelId || '');
        sessionStorage.setItem("tmsbsDefaultBqModelId", obj.tmsbsDefaultBqModelId || '');
        sessionStorage.setItem("tmsbsDefaultQdModelId", obj.tmsbsDefaultQdModelId || '');
        sessionStorage.setItem("tmsbsDefaultTydModelName", obj.tmsbsDefaultTydModelName || '');
        sessionStorage.setItem("tmsbsDefaultBqModelName", obj.tmsbsDefaultBqModelName || '');
        sessionStorage.setItem("tmsbsDefaultQdModelName", obj.tmsbsDefaultQdModelName || '');
        sessionStorage.setItem("tmsbsDefaultXfModelName", obj.tmsbsDefaultXfModelName || '');
        sessionStorage.setItem("tmsTydHxpy", obj.tmsTydHxpy || '');
        sessionStorage.setItem("tmsTydZxpy", obj.tmsTydZxpy || '');
        sessionStorage.setItem("tmsBqHxpy", obj.tmsBqHxpy || '');
        sessionStorage.setItem("tmsBqZxpy", obj.tmsBqZxpy || '');
        sessionStorage.setItem("tmsXfHxpy", obj.tmsXfHxpy || '');
        sessionStorage.setItem("tmsXfZxpy", obj.tmsXfZxpy || '');
        sessionStorage.setItem("tmsHqpzHxpy", obj.tmsHqpzHxpy || '');
        sessionStorage.setItem("tmsHqpzZxpy", obj.tmsHqpzZxpy || '');
        sessionStorage.setItem("tmsPzlHxpy", obj.tmsPzlHxpy || '');
        sessionStorage.setItem("tmsPzlZxpy", obj.tmsPzlZxpy || '');
        sessionStorage.setItem("tmsThPrintNum", obj.tmsThPrintNum || '');
        sessionStorage.setItem("tmsShPrintNum", obj.tmsShPrintNum || '');
        sessionStorage.setItem("tmsShqdPrintNum", obj.tmsShqdPrintNum || '');

        sessionStorage.setItem("tmsDbqdPrintNum", obj.tmsDbqdPrintNum || '');


        sessionStorage.setItem("tmsbsShqsPrinter", obj.tmsbsShqsPrinter || '');
        sessionStorage.setItem("tmsbsShqdPrinter", obj.tmsbsShqdPrinter || '');

        window.sessionStorage.setItem("tmsbsDbqdPrinter", obj.tmsbsDbqdPrinter || ''); 


        sessionStorage.setItem("tmsbsThqsPrinter", obj.tmsbsThqsPrinter || '');
        sessionStorage.setItem("tmsbsYshtPrinter", obj.tmsbsYshtPrinter || '');
        sessionStorage.setItem("tmsbsFkpzPrinter", obj.tmsbsFkpzPrinter || '');
        sessionStorage.setItem("tmsbsDefaultZzModelId", obj.tmsbsDefaultZzModelId || '');
        sessionStorage.setItem("tmsbsDefaultYshtModelId", obj.tmsbsDefaultYshtModelId || '');
        sessionStorage.setItem("tmsbsDefaultFkpzModelId", obj.tmsbsDefaultFkpzModelId || '');
        sessionStorage.setItem("tmsbsDefaultThqsModelId", obj.tmsbsDefaultThqsModelId || '');
        sessionStorage.setItem("tmsbsDefaultShqsModelId", obj.tmsbsDefaultShqsModelId || '');
        sessionStorage.setItem("tmsbsDefaultShqdModelId", obj.tmsbsDefaultShqdModelId || '');

        sessionStorage.setItem("tmsbsDefaultDbqdModelId", obj.tmsbsDefaultDbqdModelId || '');

        sessionStorage.setItem("tmsbsDefaultZzModelName", obj.tmsbsDefaultZzModelName || '');
        sessionStorage.setItem("tmsbsDefaultThqsModelName", obj.tmsbsDefaultThqsModelName || '');
        sessionStorage.setItem("tmsbsDefaultShqsModelName", obj.tmsbsDefaultShqsModelName || '');
        sessionStorage.setItem("tmsbsDefaultShqdModelName", obj.tmsbsDefaultShqdModelName || '');

        sessionStorage.setItem("tmsbsDefaultDbqdModelName", obj.tmsbsDefaultDbqdModelName || '');

        sessionStorage.setItem("tmsbsDefaultYshtModelName", obj.tmsbsDefaultYshtModelName || '');
        sessionStorage.setItem("tmsbsDefaultFkpzModelName", obj.tmsbsDefaultFkpzModelName || '');
      }
    });
  },
  //获取仓储打印设置
  getWarehouPrintModel: function () {
    const g = this;
    // 记录请求开始时间
    const startTime = Date.now();
    return new Promise((resolve, reject) => {
      $.newAjax({
        procParams: {
          "M": "Query",
          "N": "QSP_Printer_Set_Warehouse_ALL_V2",
        },
        data: {
          "UserId": getNewUserInfo().UserId
        },
        useCustomError: true,
        success: function (res) {
          // 计算请求耗时
          const endTime = Date.now();
          const duration = endTime - startTime;
          console.log(`接口/tmsApi/interfaceMethod/query/qsp_printer_set_warehouse_all_v2 请求耗时: ${duration}ms`);
          // 这里埋点
          const payload = {
            apiName: '/tmsApi/interfaceMethod/query/qsp_printer_set_warehouse_all_v2',
            duration: duration
          }
          window.lib && window.lib.track && window.lib.track.monitor && window.lib.track.monitor({
            category: 'custom',
            metric: {
              type: 'Gauge',
              value: duration,
              name: 't9bs.druraton.loadpage.api',
              tags: {},
              sections: payload
            },
            attrs: payload,
            ext: payload
          })
          if (res.success && res.data) {
            localStorage.setItem("warehouPrint", JSON.stringify(res.data));
            return resolve();
          } else {
            g.requestErrorMethodName.push('getWarehouPrintModel');
            return reject();
          }
        },
        error: function () {
          g.requestErrorMethodName.push('getWarehouPrintModel');
          return reject();
        }
      })
    });
  },
  // 获取操作员打印设置
  getUserDefaultInfo: function () {
    const g = this;
    // 记录请求开始时间
    const startTime = Date.now();
    return new Promise((resolve, reject) => {
      getUserDefaultInfoByCache('', {
        async: true,
        isReload: true
      }, function (data, success) {
        // 计算请求耗时
        const endTime = Date.now();
        const duration = endTime - startTime;
        console.log(`接口/loadInfo/getUserDefaultInfo 请求耗时: ${duration}ms`);
        // 这里埋点
        const payload = {
          apiName: '/loadInfo/getUserDefaultInfo',
          duration: duration
        }
        window.lib && window.lib.track && window.lib.track.monitor && window.lib.track.monitor({
          category: 'custom',
          metric: {
            type: 'Gauge',
            value: duration,
            name: 't9bs.druraton.loadpage.api',
            tags: {},
            sections: payload
          },
          attrs: payload,
          ext: payload
        })
        if (success) {
          return resolve();
        } else {
          g.requestErrorMethodName.push('getUserDefaultInfo');
          return reject();
        }
      })
    });
  },
  // 获取线路打印设置
  getLinePrintSetting: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/getLinePrintSetting',
      key: 'linePrintSetting',
      dbname: 'baseInfoDB',
      methodName: "getLinePrintSetting",
      callback: function () {
        localStorage.setItem('hasLinePrintSetting', 1);
      }
    });
  },
  // 获取到站四级地址
  getEsiteAddr: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/getEsiteAddr',
      key: 'esiteAddr',
      dbname: 'baseInfoDB',
      methodName: "getEsiteAddr",
      callback: function (data) {
        localStorage.setItem('esiteAddr', '1');
        sessionStorage.setItem('esiteAddr', '1');
        localStorage.setItem('esiteAddrData', JSON.stringify(data));
      },
      alwaysServer: true
    });
  },
  // 获取车型信息
  selectVehicleXinghao: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/selectVehicleXinghao',
      key: 'selectVehicleXinghao',
      dbname: 'baseInfoDB',
      methodName: "selectVehicleXinghao",
      callback: function () {
        sessionStorage.setItem('selectVehicleXinghao', '1');
      }
    });
  },
  // 获取结算中转费数据
  selectOutacc_c: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/selectOutacc_c',
      key: 'selectOutacc_c',
      dbname: 'baseInfoDB',
      methodName: "selectOutacc_c",
      callback: function () {
        sessionStorage.setItem('selectOutacc_c', '1');
      }
    });
  },
  // 获取结算送货费数据
  selectAccsend_c: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/selectAccsend_c',
      key: 'selectAccsend_c',
      dbname: 'baseInfoDB',
      methodName: "selectAccsend_c",
      callback: function () {
        sessionStorage.setItem('selectAccsend_c', '1');
      }
    });
  },
  // 获取符合开票的司机信息
  selectChaufferInfoBill: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/selectChaufferInfoBill',
      key: 'selectChaufferInfoBill',
      dbname: 'baseInfoDB',
      methodName: "selectChaufferInfoBill",
      callback: function () {
        sessionStorage.setItem('selectChaufferInfoBill', '1');
      }
    });
  },
  // 获取符合开票的车辆信息
  selectVehicleInfoBill: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/selectVehicleInfoBill',
      key: 'selectVehicleInfoBill',
      dbname: 'baseInfoDB',
      methodName: "selectVehicleInfoBill",
      callback: function () {
        sessionStorage.setItem('selectVehicleInfoBill', '1');
      }
    });
  },
  // 获取厂家单号设置
  selectShipperno: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/selectShipperno',
      key: 'selectShipperno',
      dbname: 'baseInfoDB',
      methodName: "selectShipperno",
      callback: function () {
        sessionStorage.setItem('selectShipperno', '1');
      }
    });
  },
  // 获取商品代码设置
  selectProductcode: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/selectProductcode',
      key: 'selectProductcode',
      dbname: 'baseInfoDB',
      methodName: "selectProductcode",
      callback: function () {
        sessionStorage.setItem('selectProductcode', '1');
      }
    });
  },
  // 获取实际发站设置
  selectDailibsite: function () {
    const g = this;
    return g.request({
      api: '/loadInfo/selectDailibsite',
      key: 'selectDailibsite',
      dbname: 'baseInfoDB',
      methodName: "selectDailibsite",
      callback: function () {
        sessionStorage.setItem('selectDailibsite', '1');
      }
    });
  },
  // 获取脱敏数据需要隐藏的字段
  PubilcDataDecryptColumn: function () {
    const g = this;
    return g.request({
      api: '/publicData/pubilcDataDecryptColumn',
      key: 'PubilcDataDecryptColumn',
      dbname: 'baseInfoDB',
      methodName: "PubilcDataDecryptColumn",
      callback: function (data) {
        try {
          sessionStorage.setItem("cardparamlist", JSON.stringify(data.dtData.cardparamlist));
          sessionStorage.setItem("idparamlist", JSON.stringify(data.dtData.idparamlist));
          sessionStorage.setItem("phoneparamlist", JSON.stringify(data.dtData.phoneparamlist));
        } catch (error) {
          console.log(error)
        }
      }
    });
  },
  // 是否启动开单自定义
  getDefaultBillingTemplateList: function () {
    const g = this;
    return g.request({
      api: '/billingCustom/getDefaultBillingTemplateList',
      key: 'GetDefaultBillingTemplateList',
      dbname: 'baseInfoDB',
      methodName: "getDefaultBillingTemplateList",
      callback: function () {}
    });
  },

  // 未启用数据脱敏但是检测到数据加密(这里的注释看不懂，搬过来的)
  isEncryptButNotUseDataDecrypt: function (res) {
    if ($.getcookie("isencrypt") != "1") return false;
    let Rows = res.data && res.data.Rows || [];
    if (Array.isArray(Rows) && Rows.length) {
      let col = JSON.stringify(Rows[0]).toLocaleUpperCase();
      if (
        col.indexOf("SHIPPERMB") > -1 ||
        col.indexOf("CONSIGNEETEL") > -1 ||
        col.indexOf("CONSIGNEEMB") > -1 ||
        col.indexOf("CONSIGNEETEL") > -1
      ) {
        for (let i = 0; i < Rows.length; i++) {
          if (i < 10) {
            let v1 = $.trim(Rows[i].shippermb);
            let v2 = $.trim(Rows[i].CONSIGNEETEL);
            let v3 = $.trim(Rows[i].CONSIGNEEMB);
            let v4 = $.trim(Rows[i].CONSIGNEETEL);
            if (
              (v1.length == 18 && new RegExp("^999.*$").test(v1)) ||
              (v2.length == 18 && new RegExp("^999.*$").test(v2)) ||
              (v3.length == 18 && new RegExp("^999.*$").test(v3)) ||
              (v4.length == 18 && new RegExp("^999.*$").test(v4))
            ) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }
}

export default baseInfo;
